import {
  CDS_FP_AUTH_STEP_QUERY,
  CDS_FP_AUTH_TAB_QUERY,
  CDS_FP_LOGIN_PATH,
} from '../constants/cdsFrequentPassenger';
import getCdsFpLoginRedirectUrl from './getCdsFpLoginRedirectUrl';

/**
 * Builds the unified CDS Pasajero Frecuente auth URL.
 * @param {object} [options]
 * @param {'login'|'signup'} [options.tab]
 * @param {'check-email'|'activation'|'success'} [options.step]
 * @param {string} [options.redirectUrl]
 * @returns {string}
 */
export default function getCdsFpAuthUrl({ tab, step, redirectUrl } = {}) {
  const params = new URLSearchParams();

  if (tab) {
    params.set(CDS_FP_AUTH_TAB_QUERY, tab);
  }

  if (step) {
    params.set(CDS_FP_AUTH_STEP_QUERY, step);
  }

  const normalizedRedirectUrl = getCdsFpLoginRedirectUrl(redirectUrl);

  if (normalizedRedirectUrl) {
    params.set('redirectUrl', normalizedRedirectUrl);
  }

  const query = params.toString();
  return query ? `${CDS_FP_LOGIN_PATH}?${query}` : CDS_FP_LOGIN_PATH;
}
